import React from 'react';
import $ from 'jquery';
import { result, each, chain } from 'underscore';
import Media from 'react-media';
import PropTypes from 'prop-types';
import { Panel, PanelType } from '@bingads-webui-react/fabric-control';
import { withPreference } from '@bingads-webui-react/preference-context';
import { Mode, withLayoutContext } from '@bingads-webui-react/app-layout-container';
import { CAMPAIGN_MAIN_MENU_MODE, largeSize as minWidth, COPILOT_WIDTH } from '@bingads-webui-campaign-react/shell-ui-common';
import { setClarityTag } from '@bingads-webui-universal/clarity';

export const withResponsiveMainMenu = (WrappedComponent) => {
  const layerHostSelector = '.app-shell-nav';
  const customWidth = '228px';
  const layerStyle = { zIndex: 220 };

  class PanelWrapper extends React.PureComponent {
    constructor(props) {
      super(props);
      this.toggleMainMenuActivity = props.mainMenuScenario.toggleMainMenuActivity.create();
      this.state = {
        isViewportSizeLarge: true,
        isPanelMode: false,
        preferencedMainMenuMode: result(props.preferenceService.findByNameAtUserLevel(props.modePreferenceName), 'Data', null),
        isCopilotExpanded: false,
      };

      props.changeLayout({
        nav: {
          mode: this.state.preferencedMainMenuMode || Mode.Collapsed,
        },
      });

      this.openPanel = this.openPanel.bind(this);
      this.dismissPanel = this.dismissPanel.bind(this);
      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.triggerPanelRepositionOnTopBannerAdd.bind(this)();
      // eslint-disable-next-line no-param-reassign
      if (props.toggleMainMenuObservable && props.toggleMainMenuObservable.subscribe) {
        props.toggleMainMenuObservable.subscribe({
          next: this.onToggle,
        });
      }
      this.MediaWithCopilot = ({ children }) => <Media query={`(min-width: ${minWidth + COPILOT_WIDTH}px)`} onChange={this.handleMediaChange}>{children}</Media>;
      this.MediaWithoutCopilot = ({ children }) => <Media query={`(min-width: ${minWidth}px)`} onChange={this.handleMediaChange}>{children}</Media>;
    }

    componentWillReceiveProps(nextProps) {
      const isCopilotExpanded = chain(nextProps).result('layoutConfig').result('copilot').result('mode')
        .value() === 'expanded';
      this.setState({
        isCopilotExpanded,
      });
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.props.mode === Mode.Hidden) {
        return;
      }

      // resize window from large size to small size
      if (prevState.isViewportSizeLarge && !this.state.isViewportSizeLarge) {
        this.props.changeLayout({
          nav: {
            mode: Mode.Collapsed,
          },
        });
      }

      // resize window from small size to large size
      if (!prevState.isViewportSizeLarge && this.state.isViewportSizeLarge) {
        this.dismissPanel();
        if (this.state.isPanelMode || this.state.preferencedMainMenuMode === Mode.Expanded || this.state.preferencedMainMenuMode === null) {
          this.props.changeLayout({
            nav: {
              mode: Mode.Expanded,
            },
          });
        }
      }
    }

    onToggle = () => {
      const {
        mode, changeLayout, preferenceService, modePreferenceName,
      } = this.props;
      setClarityTag({ toggleHamburgerMenu: 'true' });

      if (this.toggleMainMenuActivity) {
        this.toggleMainMenuActivity.trace({
          currentMode: mode,
          component: 'Main Menu',
        });
      }

      // small size page, don't change app layout, only toggle panel show/hide
      if (!this.state.isViewportSizeLarge) {
        if (this.state.isPanelMode) {
          this.dismissPanel();
        } else {
          this.openPanel();
        }
        return;
      }

      // large size page, don't show panel, only toggle app layout
      const newMode = mode === Mode.Expanded ? Mode.Collapsed : Mode.Expanded;
      this.setState({
        preferencedMainMenuMode: newMode,
      });
      preferenceService.setAtUserLevel({
        Name: modePreferenceName,
        Data: newMode,
      });
      changeLayout({
        nav: {
          mode: newMode,
        },
      });
    };

    triggerPanelRepositionOnTopBannerAdd(element = document.querySelector('.app-shell-topBanner')) {
      const observer = new MutationObserver((mutationList, obs) => {
        each(mutationList, (mutation) => {
          if (mutation.addedNodes[0] && mutation.addedNodes[0].classList.contains('notification-center-top-banner')) {
            $('.ms-Layer').css({
              top: $('.app-shell-nav').css('top'),
            });
            obs.disconnect();
          }
        });
      });

      if (element) {
        observer.observe(element, {
          childList: true,
        });
      }
    }

    handleMediaChange(matches) {
      this.setState({ isViewportSizeLarge: matches });
    }

    openPanel() {
      this.setState({ isPanelMode: true });
      this.props.hamburgerStore.setState({
        isPanelMode: true,
      });
    }

    dismissPanel() {
      this.setState({ isPanelMode: false });
      this.props.hamburgerStore.setState({
        isPanelMode: false,
      });
    }

    render() {
      const MainMenuComponent = <WrappedComponent {...this.props} isPanelMode={this.state.isPanelMode} onToggle={this.onToggle} />;
      const MediaComp = this.state.isCopilotExpanded ?
        this.MediaWithCopilot :
        this.MediaWithoutCopilot;

      return (
        <MediaComp>
          {matches =>
            (!matches && this.state.isPanelMode ?
              <Panel
                isOpen={this.state.isPanelMode}
                type={PanelType.customNear}
                onDismiss={(e) => {
                  if (!$(e.target).hasClass('iconba-GlobalNavButton')) {
                    this.setState({ isPanelMode: false });
                  }
                 }}
                hasCloseButton={false}
                layerProps={{
                    styles: {
                      root: {
                        ...layerStyle,
                        top: document.querySelector(layerHostSelector) ? document.querySelector(layerHostSelector).offsetTop : 0,
                      },
                    },
                    eventBubblingEnabled: true,
                }}
                overlayProps={{
                  styles: {
                    root: {
                      cursor: 'default',
                    },
                  },
                }}
                isLightDismiss
                isHiddenOnDismiss
                customWidth={customWidth}
                className="responsive-main-menu-panel"
                styles={{
                  content: { padding: '0px' },
                  main: { animation: 'none', backgroundColor: '#edebe9', overflow: 'visible' },
                }}
              >
                {MainMenuComponent}
              </Panel>
              : MainMenuComponent
            )
          }
        </MediaComp>
      );
    }
  }

  PanelWrapper.propTypes = {
    changeLayout: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
    preferenceService: PropTypes.shape({
      setAtUserLevel: PropTypes.func,
      findByNameAtUserLevel: PropTypes.func,
    }).isRequired,
    mainMenuScenario: PropTypes.shape({
      toggleMainMenuActivity: PropTypes.any,
    }).isRequired,
    modePreferenceName: PropTypes.string,
    toggleMainMenuObservable: PropTypes.shape({
      subscribe: PropTypes.func,
    }),
    hamburgerStore: PropTypes.shape({
      setState: PropTypes.func.isRequired,
    }).isRequired,
    layoutConfig: PropTypes.shape({
      copilot: PropTypes.shape({
        mode: PropTypes.string,
      }),
    }).isRequired,
  };

  PanelWrapper.defaultProps = {
    modePreferenceName: CAMPAIGN_MAIN_MENU_MODE,
    toggleMainMenuObservable: undefined,
  };

  return withLayoutContext(withPreference(PanelWrapper));
};
